// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"398cd23c","421":"0cafcf52","520":"d9c1f5b0","638":"806e12d1","770":"f85204b1","843":"edbc36db"}[chunkId] + ".chunk.css";
};